import React from 'react';
import {SubmitHandler} from 'react-hook-form';
import {useSearchParams} from 'react-router-dom';
import {t} from '@lingui/core/macro';

import ModalBlockButton from 'shared/ui/Button/ModalBlockButton/ModalBlockButton';
import IDomainIncidentFilters from 'features/domain/model/DomainIncident/IDomainIncidentFilters';
import {
    allValueToUndefined,
    buildFiltersSearchParams,
    dateRangeToFilters,
    sortToUrlFilters,
} from 'shared/lib/filterHelper';

import {IDomainIncidentsFiltersForm} from 'features/domain/model/DomainIncident/IDomainIncidentsFiltersForm';

import DomainIncidentsFiltersForm from './DomainIncidentsFiltersForm';

const DOMAIN_INCIDENT_TYPE_FILTER_PARAM = 'type[]';

interface IDomainIncidentsFiltersFormHandlerProps {
    onSuccess: () => void;
    handleClose: () => void;
}

const DomainIncidentsFiltersFormHandler: React.FC<IDomainIncidentsFiltersFormHandlerProps> = ({
    onSuccess,
    handleClose,
}) => {
    const [searchParams, setSearchParams] = useSearchParams();

    const onSubmit: SubmitHandler<IDomainIncidentsFiltersForm> = async({
        domain,
        domainMonitor,
        type,
        // eslint-disable-next-line camelcase
        created_at,
        // eslint-disable-next-line camelcase
        expire_at,
        // eslint-disable-next-line camelcase
        resolved_at,
        orderBy,
        ...rest
    }) => {
        const filters: IDomainIncidentFilters = {
            ...rest,
            domain,
            'domain_monitor.uuid': allValueToUndefined(domainMonitor),
        };

        dateRangeToFilters(created_at, filters, 'created_at');
        dateRangeToFilters(expire_at, filters, 'expire_at');
        dateRangeToFilters(resolved_at, filters, 'resolved_at');

        const params = buildFiltersSearchParams(searchParams, {...filters, ...sortToUrlFilters(orderBy)});

        params.delete(DOMAIN_INCIDENT_TYPE_FILTER_PARAM);
        type?.forEach(item => params.append(DOMAIN_INCIDENT_TYPE_FILTER_PARAM, item));

        setSearchParams(params);

        onSuccess();
    };

    return (
        <DomainIncidentsFiltersForm
            onSubmit={onSubmit}
            button={
                <ModalBlockButton
                    primaryButtonText={t`Применить фильтры`}
                    primaryButtonType="submit"
                    secondaryButtonOnClick={handleClose}
                />
            }
        />
    );
};

export default DomainIncidentsFiltersFormHandler;
